@for (item of dataSources() | keyvalue; track item.key) {
  <ng-container
    *ngTemplateOutlet="
      mediaItemTemplate;
      context: { item: item.value, ownerKey: item.key }
    "
  ></ng-container>
}

<ng-template #mediaItemTemplate let-item="item" let-ownerKey="ownerKey">
  <hs-card [hsLayer]="'one'">
    <hs-card-body>
      <div class="flex flex-row w-full gap-4 items-center">
        <hs-icon [width]="32" [height]="32" [innerHTML]="icon"></hs-icon>
        <div hsCardTitle>{{ item.title }}</div>
        <span class="flex-1"></span>
        @if (isEditable) {
          <button
            hsButton
            hsButtonSize="sm"
            hsButtonVariant="filled"
            (click)="onAddFromGalleryClicked(ownerKey, item)"
          >
            <!-- [hsMenuTrigger]="menu" -->
            <hs-icon [innerHTML]="iconNew"></hs-icon>
            {{ newMediaLabel }}
          </button>
        }

        <!-- <ng-template #menu>
          <hs-menu>
            <hs-menu-item (click)="onAddFromGalleryClicked(ownerKey, item)">{{
              fromGalleryLabel
            }}</hs-menu-item>
            <hs-menu-item (click)="onAddFromCameraClicked(ownerKey, item)">{{
              fromCameraLabel
            }}</hs-menu-item>
          </hs-menu>
        </ng-template> -->
      </div>

      <hs-media-gallery
        [dataSource]="item.dataSource"
        #mediaItem
      ></hs-media-gallery>
      @if (item.dataSource && item.dataSource.data().length > 0) {
        <hs-pagination
          hsLayer="one"
          [dataSource]="item.dataSource"
        ></hs-pagination>
      }
    </hs-card-body>
  </hs-card>
</ng-template>
